export const CONFIRMED_FILTER_ALL = 'BILLING-ACTIVITY-OVERVIEW/CONFIRMED_FILTER_ALL';
export const CONFIRMED_FILTER_CONFIRMED = 'BILLING-ACTIVITY-OVERVIEW/CONFIRMED_FILTER_CONFIRMED';
export const CONFIRMED_FILTER_UNCONFIRMED = 'BILLING-ACTIVITY-OVERVIEW/CONFIRMED_FILTER_UNCONFIRMED';
